import { Message } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";

import { db } from "astrid-firebase";
import articleTypes from "astrid-firestore/src/api/articles/constants/articleTypes";
import { useDocumentData } from "astrid-firestore/src/hooks";

import ArtifactExpiredExportsView from "../views/ArtifactExportsView/ArtifactExpiredExportsView";
import ArtifactExportsView from "../views/ArtifactExportsView/ArtifactExportsView";

export default function ArtifactExports() {
	const { artifact, publisher } = useOutletContext();
	const { t } = useTranslation();

	// Artifacts without an article can still be assigned to one in their production
	const [production] = useDocumentData(!artifact?.article && artifact?.production?.ref);

	const productionArticleId = Object.entries(production?.articles || {}).find(([, { artifactIds }]) =>
		artifactIds?.includes(artifact.id),
	)?.[0];

	const [article] = useDocumentData(
		artifact?.article?.ref || (productionArticleId && db.collection("articles").doc(productionArticleId)),
	);

	if (artifact?.article?.type === articleTypes.EBOOK) {
		return <Message info content={t("exportsNotAvailable", "Exports are not available for ebooks")} />;
	}

	return (
		<>
			<ArtifactExportsView article={article} artifact={artifact} publisher={publisher} />
			<ArtifactExpiredExportsView artifact={artifact} />
		</>
	);
}
